/**
 * PREVIEW PAGE
 *
 * Replit/Lovable-style live preview with AI chat.
 * Shows dev environment iframes with an AI assistant sidebar.
 */

import { useEffect } from "react";
import { useWorldStore } from "@/stores/worldStore";
import { useWorkspaceStore } from "@/stores/workspaceStore";
import { useUIStore } from "@/stores/uiStore";
import { PreviewLayout } from "@/features/preview/PreviewLayout";

export default function PreviewPage() {
  const { fetchWorldData } = useWorldStore();
  const { ensureWorkspaceReady } = useWorkspaceStore();
  const { theme } = useUIStore();

  useEffect(() => {
    (async () => {
      await ensureWorkspaceReady();
      await fetchWorldData();
    })().catch((err) => console.error("[PreviewPage] workspace init failed:", err));
  }, [ensureWorkspaceReady, fetchWorldData]);

  useEffect(() => {
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [theme]);

  return (
    <div className="w-full h-full flex flex-col overflow-hidden" data-testid="container-preview-page">
      <PreviewLayout />
    </div>
  );
}
